import { useCallback, useEffect, useState } from "react";
import { Trash2, MailOpen, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

export default function MessagesTab({ onChanged }) {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/admin/messages").then((r) => setRows(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const refresh = () => { load(); onChanged?.(); };

  const toggleRead = async (m) => {
    try {
      await api.patch(`/admin/messages/${m.id}`, { read: !m.read });
      refresh();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  const remove = async (m) => {
    if (!window.confirm(`Supprimer définitivement le message de ${m.name} ?`)) return;
    try {
      await api.delete(`/admin/messages/${m.id}`);
      toast.success("Message supprimé");
      refresh();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-3" data-testid="messages-tab">
      {rows.map((m) => (
        <div key={m.id} className={`border bg-panel p-5 ${m.read ? "border-white/10" : "border-brass/40"}`} data-testid={`message-${m.id}`}>
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="text-sm font-semibold text-bone">
                {m.name} <span className="font-normal text-muted-foreground">· {m.email} {m.phone}</span>
                {!m.read && <span className="ml-2 bg-brass/20 px-2 py-0.5 text-[10px] uppercase tracking-wider text-brass">non lu</span>}
              </p>
              <p className="mt-0.5 text-xs text-muted-foreground">{m.subject}</p>
            </div>
            <div className="flex shrink-0 items-center gap-3">
              <button onClick={() => toggleRead(m)} className="text-xs text-brass underline" data-testid={`toggle-message-${m.id}`}>
                {m.read ? <Mail size={14} /> : <MailOpen size={14} />}
                {m.read ? " Marquer non lu" : " Marquer lu"}
              </button>
              <a href={`mailto:${m.email}`} className="text-xs underline" data-testid={`reply-message-${m.id}`}>Répondre</a>
              <button onClick={() => remove(m)} className="text-destructive" data-testid={`delete-message-${m.id}`}>
                <Trash2 size={15} />
              </button>
            </div>
          </div>
          <p className="mt-3 whitespace-pre-line text-sm text-muted-foreground">{m.message}</p>
        </div>
      ))}
      {!rows.length && <p className="border border-white/10 bg-panel p-10 text-center text-sm text-muted-foreground">Aucun message.</p>}
    </div>
  );
}
